import React from 'react';
import { FileCode, FolderOpen, Rocket } from 'lucide-react';
import Button from '../UI/Button';

const QuickActions = ({ onGenerateProject, onViewProjects }) => {
  const actions = [
    {
      icon: <Rocket className="h-6 w-6" />,
      title: 'Generate Project',
      description: 'Create a new project with AI',
      onClick: onGenerateProject,
      color: 'blue'
    },
    {
      icon: <FolderOpen className="h-6 w-6" />,
      title: 'View All Projects',
      description: 'Manage your existing projects',
      onClick: onViewProjects,
      color: 'green'
    }
  ];

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {actions.map((action, index) => (
          <button
            key={index}
            onClick={action.onClick}
            className="flex items-start p-4 text-left rounded-lg border border-gray-200 hover:border-blue-300 hover:bg-blue-50 transition-colors"
          >
            <div className={`p-2 rounded-lg ${
              action.color === 'blue' ? 'bg-blue-100 text-blue-600' : 'bg-green-100 text-green-600'
            }`}>
              {action.icon}
            </div>
            <div className="ml-3">
              <h4 className="font-medium text-gray-900">{action.title}</h4>
              <p className="text-sm text-gray-600 mt-1">{action.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;